import httpClient from '@/http-client'

export const dailySaleItem = data => {
  return httpClient
    .post('/api/report/daily-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const dailySaleItemExcel = attributes => {
  return httpClient
    .post('/api/report/daily-sale-item-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const saleItemDetail = data => {
  return httpClient
    .post('/api/report/sale-item-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const saleItemDetailExcel = attributes => {
  return httpClient
    .post('/api/report/sale-item-detail-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInDetail = data => {
  return httpClient
    .post('/api/report/stock-in-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInDetailExcel = attributes => {
  return httpClient
    .post('/api/report/stock-in-detail-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInSummary = data => {
  return httpClient
    .post('/api/report/stock-in-summaries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInSummaryExcel = attributes => {
  return httpClient
    .post('/api/report/stock-in-summary-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const detailInventoryList = data => {
  return httpClient
    .post('/api/report/detail-inventory-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const detailInventoryListExcel = attributes => {
  return httpClient
    .post('/api/report/detail-inventory-list-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const summaryInventoryList = data => {
  return httpClient
    .post('/api/report/summary-inventory-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const summaryInventoryListExcel = attributes => {
  return httpClient
    .post('/api/report/summary-inventory-list-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const productItemList = data => {
  return httpClient
    .post('/api/report/product-item-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const purchaseOrderList = data => {
  return httpClient
    .post('/api/report/purchase-order-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const purchaseOrderSummary = data => {
  return httpClient
    .post('/api/report/purchase-order-summaries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlySaleItem = data => {
  return httpClient
    .post('/api/report/monthly-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlySaleItemExcel = attributes => {
  return httpClient
    .post('/api/report/monthly-sale-item-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const stockTransfer = data => {
  return httpClient
    .post('/api/report/stock-transfers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockTransferExcel = attributes => {
  return httpClient
    .post('/api/report/stock-transfers-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const yearlySaleItem = data => {
  return httpClient
    .post('/api/report/yearly-sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const inventoryListHeadOffice = data => {
  return httpClient
    .get('/api/report/inventory-list-head-offices', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const inventoryListHeadOfficeExcel = attributes => {
  return httpClient
    .post('/api/report/inventory-list-head-office-excel-exports', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  dailySaleItem,
  dailySaleItemExcel,
  saleItemDetail,
  saleItemDetailExcel,
  stockInDetail,
  stockInDetailExcel,
  stockInSummary,
  stockInSummaryExcel,
  detailInventoryList,
  detailInventoryListExcel,
  summaryInventoryList,
  summaryInventoryListExcel,
  productItemList,
  purchaseOrderList,
  purchaseOrderSummary,
  monthlySaleItem,
  stockTransfer,
  yearlySaleItem,
  monthlySaleItemExcel,
  stockTransferExcel,
  inventoryListHeadOffice,
  inventoryListHeadOfficeExcel
}
